import { FetchCustomerBillsParams, FetchCustomerCommissionBillsParams } from 'src/api/customer/downloads';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from 'src/store/actions';

/* Customer Downloads Types */
export const FETCH_CUSTOMER_DOWNLOAD_TOPICS = 'FETCH_CUSTOMER_DOWNLOAD_TOPICS';
export const REQUEST_CUSTOMER_DOWNLOAD_TOPICS = 'REQUEST_CUSTOMER_DOWNLOAD_TOPICS';
export const SUCCESS_CUSTOMER_DOWNLOAD_TOPICS = 'SUCCESS_CUSTOMER_DOWNLOAD_TOPICS';
export const FAILURE_CUSTOMER_DOWNLOAD_TOPICS = 'FAILURE_CUSTOMER_DOWNLOAD_TOPICS';

export const fetchCustomerDownloadTopics = () => action(FETCH_CUSTOMER_DOWNLOAD_TOPICS);
export const requestCustomerDownloadTopics = () => action(REQUEST_CUSTOMER_DOWNLOAD_TOPICS);
export const requestCustomerDownloadTopicsSuccess = (response: any) =>
    action(SUCCESS_CUSTOMER_DOWNLOAD_TOPICS, { response });
export const requestCustomerDownloadTopicsFailure = (error: any) => action(FAILURE_CUSTOMER_DOWNLOAD_TOPICS, { error });

/* Customer Downloads */
export const FETCH_CUSTOMER_DOWNLOADS = 'FETCH_CUSTOMER_DOWNLOADS';
export const REQUEST_CUSTOMER_DOWNLOADS = 'REQUEST_CUSTOMER_DOWNLOADS';
export const SUCCESS_CUSTOMER_DOWNLOADS = 'SUCCESS_CUSTOMER_DOWNLOADS';
export const FAILURE_CUSTOMER_DOWNLOADS = 'FAILURE_CUSTOMER_DOWNLOADS';

export const fetchCustomerDownloads = (typeName: string, pageable?: PageableQueryParams) =>
    action(FETCH_CUSTOMER_DOWNLOADS, { typeName, pageable });
export const requestCustomerDownloads = () => action(REQUEST_CUSTOMER_DOWNLOADS);
export const requestCustomerDownloadsSuccess = (response: any) => action(SUCCESS_CUSTOMER_DOWNLOADS, { response });
export const requestCustomerDownloadsFailure = (error: any) => action(FAILURE_CUSTOMER_DOWNLOADS, { error });

/* Customer Bills Info */
export const FETCH_CUSTOMER_BILLS_INFO = 'FETCH_CUSTOMER_BILLS_INFO';
export const REQUEST_CUSTOMER_BILLS_INFO = 'REQUEST_CUSTOMER_BILLS_INFO';
export const SUCCESS_CUSTOMER_BILLS_INFO = 'SUCCESS_CUSTOMER_BILLS_INFO';
export const FAILURE_CUSTOMER_BILLS_INFO = 'FAILURE_CUSTOMER_BILLS_INFO';

export const fetchCustomerBillsInfo = () => action(FETCH_CUSTOMER_BILLS_INFO);
export const requestCustomerBillsInfo = () => action(REQUEST_CUSTOMER_BILLS_INFO);
export const requestCustomerBillsInfoSuccess = (response: any) => action(SUCCESS_CUSTOMER_BILLS_INFO, { response });
export const requestCustomerBillsInfoFailure = (error: any) => action(FAILURE_CUSTOMER_BILLS_INFO, { error });

/* Customer Bills */
export const FETCH_CUSTOMER_BILLS = 'FETCH_CUSTOMER_BILLS';
export const REQUEST_CUSTOMER_BILLS = 'REQUEST_CUSTOMER_BILLS';
export const SUCCESS_CUSTOMER_BILLS = 'SUCCESS_CUSTOMER_BILLS';
export const FAILURE_CUSTOMER_BILLS = 'FAILURE_CUSTOMER_BILLS';

export const fetchCustomerBills = (params: FetchCustomerBillsParams, pageable?: PageableQueryParams) =>
    action(FETCH_CUSTOMER_BILLS, { params, pageable });
export const requestCustomerBills = () => action(REQUEST_CUSTOMER_BILLS);
export const requestCustomerBillsSuccess = (response: any) => action(SUCCESS_CUSTOMER_BILLS, { response });
export const requestCustomerBillsFailure = (error: any) => action(FAILURE_CUSTOMER_BILLS, { error });

/* Customer Commission Bills Info */
export const FETCH_CUSTOMER_COMMISSION_BILLS_INFO = 'FETCH_CUSTOMER_COMMISSION_BILLS_INFO';
export const REQUEST_CUSTOMER_COMMISSION_BILLS_INFO = 'REQUEST_CUSTOMER_COMMISSION_BILLS_INFO';
export const SUCCESS_CUSTOMER_COMMISSION_BILLS_INFO = 'SUCCESS_CUSTOMER_COMMISSION_BILLS_INFO';
export const FAILURE_CUSTOMER_COMMISSION_BILLS_INFO = 'FAILURE_CUSTOMER_COMMISSION_BILLS_INFO';

export const fetchCustomerCommissionBillsInfo = () => action(FETCH_CUSTOMER_COMMISSION_BILLS_INFO);
export const requestCustomerCommissionBillsInfo = () => action(REQUEST_CUSTOMER_COMMISSION_BILLS_INFO);
export const requestCustomerCommissionBillsInfoSuccess = (response: any) =>
    action(SUCCESS_CUSTOMER_COMMISSION_BILLS_INFO, { response });
export const requestCustomerCommissionBillsInfoFailure = (error: any) =>
    action(FAILURE_CUSTOMER_COMMISSION_BILLS_INFO, { error });

/* Customer Commission Bills */
export const FETCH_CUSTOMER_COMMISSION_BILLS = 'FETCH_CUSTOMER_COMMISSION_BILLS';
export const REQUEST_CUSTOMER_COMMISSION_BILLS = 'REQUEST_CUSTOMER_COMMISSION_BILLS';
export const SUCCESS_CUSTOMER_COMMISSION_BILLS = 'SUCCESS_CUSTOMER_COMMISSION_BILLS';
export const FAILURE_CUSTOMER_COMMISSION_BILLS = 'FAILURE_CUSTOMER_COMMISSION_BILLS';

export const fetchCustomerCommissionBills = (
    params: FetchCustomerCommissionBillsParams,
    pageable?: PageableQueryParams
) => action(FETCH_CUSTOMER_COMMISSION_BILLS, { params, pageable });
export const requestCustomerCommissionBills = () => action(REQUEST_CUSTOMER_COMMISSION_BILLS);
export const requestCustomerCommissionBillsSuccess = (response: any) =>
    action(SUCCESS_CUSTOMER_COMMISSION_BILLS, { response });
export const requestCustomerCommissionBillsFailure = (error: any) =>
    action(FAILURE_CUSTOMER_COMMISSION_BILLS, { error });
